import { createMatchSelector } from "connected-react-router";
import { EQUIPMENT_MEMBER_ROUTE } from "../actions/types";

export const getEquipmentById = (state) => {
	const match = createMatchSelector(EQUIPMENT_MEMBER_ROUTE)(state);

	if (match && match.params && match.params.equipmentId) {
		const equipmentList = state.equipment?.data || [];

		for (let i = 0; i < equipmentList.length; i++) {
			const equipment = equipmentList[i];

			if (equipment.id === match.params.equipmentId) {
				return equipment;
			}
		}
	}

	return null;
};
